export default "__VITE_ASSET__hLqDMD_Y__"